"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateConfig = void 0;
const validateConfig = (config) => {
    var _a;
    // validate common config as needed; return BAD_CONFIG failure if need be
    // Set default values
    config.authentication.goToSignOutOnFailure = (_a = config.authentication.goToSignOutOnFailure) !== null && _a !== void 0 ? _a : true;
    return { ok: true };
};
exports.validateConfig = validateConfig;
